import { render, staticRenderFns } from "./Efetivacao.vue?vue&type=template&id=eca0bf1e"
import script from "./Efetivacao.vue?vue&type=script&lang=js"
export * from "./Efetivacao.vue?vue&type=script&lang=js"
import style0 from "./Efetivacao.vue?vue&type=style&index=0&id=eca0bf1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VDivider,VFileInput,VForm,VOverlay,VRow,VTextarea})
